import { Languages, Environment } from '@shared/models';

export const environment: Environment = {
  production: true,
  defaultLanguage: Languages.EN,
  apiHost: 'https://user-auth-api.rpartners-dev.com/api/v1/',
};
